import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { IDeleteOrderResult } from "./types";

interface IDeleteChangeSimEsimProps {
  orchestratorId: string;
}

export async function deleteChangeSimEsim({
  orchestratorId,
}: IDeleteChangeSimEsimProps): Promise<IDeleteOrderResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orchestrators/${orchestratorId}/actions/DELETE`,
    {
      method: "post",
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(undefined);
}
